import { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const BASE_URL = "https://nissi-india.com";
const LOGO_URL = "/assets/company-logo.png";

const SalaryStatementPrint = () => {
  const params = useMemo(() => new URLSearchParams(window.location.search), []);
  const finYearId =
    params.get("finYearId") || localStorage.getItem("finYearId") || "";
  const loginBranchId =
    params.get("loginBranchId") || localStorage.getItem("branchId") || "";
  const branchId = params.get("branchId") || "Select";
  const monthName = params.get("monthName") || "Select";
  const year = params.get("year") || "Select";
  const isPF = params.get("isPF") || "Yes";

  const [loading, setLoading] = useState(false);
  const [cashRows, setCashRows] = useState([]);
  const [bankRows, setBankRows] = useState([]);

  const fetchPrintData = async () => {
    try {
      setLoading(true);

      const res = await axios.get(
        `${BASE_URL}/api/salary-statement/print-data`,
        {
          params: {
            finYearId: Number(finYearId),
            loginBranchId: Number(loginBranchId),
            branchId: String(branchId),
            monthName,
            year,
            isPF,
          },
        }
      );

      if (res?.data?.success) {
        setCashRows(res.data.cashRows || []);
        setBankRows(res.data.bankRows || []);
        setTimeout(() => window.print(), 400);
      } else {
        toast.error("Failed to load print data.");
      }
    } catch (err) {
      toast.error("Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPrintData();
  }, []);

  const HeaderBlock = () => (
    <div className="reportHeader">
      <div className="logoBox">
        <img
          src={LOGO_URL}
          alt="Logo"
          onError={(e) => (e.currentTarget.style.display = "none")}
        />
      </div>
      <div className="companyBox">
        <div className="companyName">Nissi Infotech</div>
        <div className="companySub">CIVIL CONSTRUCTION</div>
        <div className="companyLine">
          3/42-12, Nagappa Gounder St, Kavundampalayam, Coimbatore-30, Tamil Nadu
        </div>
        <div className="companyLine">Phone No : 9003744644</div>
        <div className="companyLine">
          infraconsoft-implementation@nissiinfotech.in
        </div>
      </div>
    </div>
  );

  const TitleBlock = ({ label }) => (
    <div className="titleRow">
      <div className="titleText">{label}</div>
      <div className="metaText">
        Month: <b>{monthName}</b> | Year: <b>{year}</b> | PF: <b>{isPF}</b>
      </div>
    </div>
  );

  const Table = ({ rows }) => (
    <table className="reportTable">
      <thead>
        <tr>
          <th>S.No</th>
          <th>Code</th>
          <th>Name</th>
          <th>Designation</th>
          <th>Account No</th>
          <th>Gross</th>
          <th>Basic</th>
          <th>Leave</th>
          <th>Paid</th>
          <th>Conv.</th>
          <th>Edu.</th>
          <th>HRA</th>
          <th>PF</th>
          <th>ESI</th>
          <th>Adv.</th>
          <th>Bal.</th>
          <th>Net</th>
          <th>Sign</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((r, i) => (
          <tr key={i}>
            <td>{i + 1}</td>
            <td>{r.fld_employeecode}</td>
            <td className="left">{r.fld_employee}</td>
            <td>{r.fld_designationname}</td>
            <td>{r.fld_accountno}</td>
            <td>{r.fld_grosssalary}</td>
            <td>{r.fld_basicpay}</td>
            <td>{r.fld_lopamt}</td>
            <td>{r.fld_paidbasic}</td>
            <td>{r.fld_conveyance}</td>
            <td>{r.fld_educational}</td>
            <td>{r.fld_hra}</td>
            <td>{r.fld_pf}</td>
            <td>{r.fld_esi}</td>
            <td>{r.advance}</td>
            <td>{r.advbal}</td>
            <td>{r.fld_netpay}</td>
            <td></td>
          </tr>
        ))}
      </tbody>
    </table>
  );

  return (
    <div className="printRoot">
      <ToastContainer autoClose={2000} />
      <div className="pageFrame">
        <HeaderBlock />

        <TitleBlock label="SALARY STATEMENT (CASH)" />
        <Table rows={cashRows} />

        <div className="pageBreak" />

        <TitleBlock label="SALARY STATEMENT (BANK)" />
        <Table rows={bankRows} />

        {loading && <div>Loading...</div>}
      </div>

      <style>{`
        body { margin:0; font-family: Arial, sans-serif; }

        .printRoot { padding: 10px; }

        .pageFrame { width: 100%; }

        .reportHeader {
          border:1px solid #000;
          display:grid;
          grid-template-columns:120px 1fr;
          padding:10px;
        }

        .logoBox img { max-width:100px; }

        .companyBox { text-align:center; }
        .companyName { font-weight:bold; font-size:18px; }
        .companySub { font-weight:bold; font-size:13px; }
        .companyLine { font-size:11px; }

        .titleRow { text-align:center; margin-top:15px; }
        .titleText { font-weight:bold; font-size:15px; }
        .metaText { font-size:11px; }

        .reportTable {
          width:100%;
          border-collapse:collapse;
          table-layout:fixed;
          font-size:9px;
          margin-top:8px;
        }

        .reportTable th,
        .reportTable td {
          border:1px solid #000;
          padding:3px;
          text-align:center;
          word-wrap:break-word;
        }

        .reportTable th { font-weight:bold; }

        .left { text-align:left; }

        .pageBreak { margin-top:20px; }

        @media print {
          .pageBreak { page-break-before:always; }

          @page {
            size: A4 landscape;
            margin:8mm;
          }
        }
      `}</style>
    </div>
  );
};

export default SalaryStatementPrint;
